import apiClient from '../api';
import { PEDCycle, PEDCompound, DailyPEDLog } from '../../types';

export const pedService = {
  // =========== Compounds ===========
  getCompounds: async (): Promise<PEDCompound[]> => {
    const response = await apiClient.get('/ped/compounds');
    return response.data;
  },

  // =========== Cycles ===========
  // Supports viewAs for coach read-only access
  getCycles: async (viewAs?: string): Promise<PEDCycle[]> => {
    const params = viewAs ? { viewAs } : undefined;
    const response = await apiClient.get('/ped/cycles', { params });
    return response.data;
  },

  getCycle: async (id: string): Promise<PEDCycle> => {
    const response = await apiClient.get(`/ped/cycles/${id}`);
    return response.data;
  },

  getActiveCycle: async (): Promise<PEDCycle | null> => {
    try {
      const response = await apiClient.get('/ped/cycles/active');
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  createCycle: async (cycle: Partial<PEDCycle>): Promise<PEDCycle> => {
    const response = await apiClient.post('/ped/cycles', cycle);
    return response.data;
  },

  updateCycle: async (id: string, cycle: Partial<PEDCycle>): Promise<void> => {
    await apiClient.put(`/ped/cycles/${id}`, cycle);
  },

  deleteCycle: async (id: string): Promise<void> => {
    await apiClient.delete(`/ped/cycles/${id}`);
  },

  // =========== Daily Logs ===========
  // Supports viewAs for coach read-only access
  getLogs: async (params?: {
    startDate?: string;
    endDate?: string;
    viewAs?: string;
  }): Promise<DailyPEDLog[]> => {
    const response = await apiClient.get('/ped/logs', { params });
    return response.data;
  },

  getLogsByDate: async (date: string): Promise<DailyPEDLog[]> => {
    const response = await apiClient.get(`/ped/logs/date/${date}`);
    return response.data;
  },

  createLog: async (log: Partial<DailyPEDLog>): Promise<DailyPEDLog> => {
    const response = await apiClient.post('/ped/logs', log);
    return response.data;
  },

  updateLog: async (id: string, log: Partial<DailyPEDLog>): Promise<void> => {
    await apiClient.put(`/ped/logs/${id}`, log);
  },

  deleteLog: async (id: string): Promise<void> => {
    await apiClient.delete(`/ped/logs/${id}`);
  },
};
